import React, { useState, useEffect, useRef } from "react";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import ReportsGemstoneService from "../../../services/reports-Gemstone.service";
import GlobalGemstoneReportService from "../../../services/reports-globalGemstone-service";
import { useSelector } from "react-redux";
import moment from "moment";
import { BlobToDownloadFile } from "../../../helper/commanFunction";
import { Button, DatePicker, Spin, Table, Tooltip, message } from "antd";
import Chart from "react-google-charts";

const { RangePicker } = DatePicker;

const GemstoneVendorBasedAddToCartReport = () => {
  const { t } = useTranslation();
  const GemstoneCutChartRef = useRef();
  
  /*Initial State for Binding Starts*/
  const initialGlobalGemstoneState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
  };
  /*Initial State for Binding Ends*/
  
  /*React Binding Starts*/
  const [TableForAllList, setTableForAllList] = useState([]);
  const [globalGemstones, setGlobalGemstone] = useState(initialGlobalGemstoneState);
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [TableForAllLoading, setTableForAllLoading] = useState(false);
  const [TotalGemstoneClicks, setTotalGemstoneClicks] = useState(0);
  const [dealerId, setDealerId] = useState();
  const [forDealer, setForDealer] = useState("");
  const loginDetials = useSelector((state) => state.loginReducer);
  const [gemstoneCutGradeSearchesLabels, setgemstoneCutGradeSearchesLabels] = useState([]);
  const [GemstoneCutGradeSearchesList, setGemstoneCutGradeSearchesList] = useState([]);
  const [GemstoneCutGradeColorData, setGemstoneCutGradeColorData] = useState([]);
  const [GemstoneCutGradeYAxisList, setGemstoneCutGradeYAxisList] = useState([]);
  const [TableCutGradeValue, setTableCutGradeValue] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [sortType, setSortType] = useState("desc");
  const [sortColumnName, setSortColumnName] = useState("AK.Date");
  const [key, setKey] = useState(true);
  const [downloadCSVDataloading, setDownloadCSVDataloading] = useState(false);
  const [downloadPDFDataloading, setDownloadPDFDataloading] = useState(false);

  // New state for custom legends and max entries
  const [chartData, setChartData] = useState([]);
  const [colorData, setColorData] = useState([]);
  const [processedVendorLabels, setProcessedVendorLabels] = useState([]);
  const [processedVendorCounts, setProcessedVendorCounts] = useState([]);

  // Configuration
  const MAX_ENTRIES = 15; // Maximum bars to show
  const chartColors = [
    "#0EDCE8", "#109618", "#FF9900", "#990099", "#0099C6",
    "#3366CC", "#DC3912", "#66AA00", "#DD4477", "#EDED01",
    "#B82E2E", "#316395", "#994499", "#22AA99", "#AAAA11",
    "#6633CC", "#E67300", "#8B0707", "#329262", "#3B3EAC"
  ];

  /*React Binding Ends*/

  // Process chart data with max entries limit for bar chart
  const processChartData = (vendors, counts) => {
    if (!vendors?.length || !counts?.length || vendors.length !== counts.length) {
      return { chartData: [], colors: [], processedLabels: [], processedCounts: [] };
    }

    // Combine vendors and counts into objects
    const combinedData = vendors.map((vendor, index) => ({
      vendor,
      count: counts[index],
      originalIndex: index
    }));

    // Filter out zero values and sort by count (descending)
    const filteredData = combinedData.filter(item => item.count > 0);
    const sortedData = [...filteredData].sort((a, b) => b.count - a.count);

    // Apply max entries limit
    const topData = sortedData.slice(0, MAX_ENTRIES);
    const remainingData = sortedData.slice(MAX_ENTRIES);

    // Calculate "Others" if needed
    const othersValue = remainingData.reduce((sum, item) => sum + item.count, 0);
    if (othersValue > 0 && remainingData.length > 0) {
      topData.push({
        vendor: t("Others"),
        count: othersValue,
        isOthers: true
      });
    }

    // Prepare chart data
    const processedChartData = [["Vendor", "Count", { role: "style" }]];
    const colors = [];
    const processedLabels = [];
    const processedCounts = [];

    topData.forEach((item, index) => {
      const color = chartColors[index % chartColors.length];
      colors.push(color);
      
      // For Google Charts with style
      processedChartData.push([item.vendor, item.count, `color: ${color}`]);
      
      // Store processed data for other uses
      processedLabels.push(item.vendor);
      processedCounts.push(item.count);
    });

    return { 
      chartData: processedChartData, 
      colors, 
      processedLabels, 
      processedCounts 
    };
  };

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    if (TableCutGradeValue) {
      handleGetGemstoneReportForTableChartAll(
        dealerId,
        forDealer,
        1,
        15,
        "AK.Date",
        "asc"
      );
      setSortColumnName("AK.Date");
      setSortType("desc");
      setPageNo(1);
      setPageSize(15);
    }
  }, [TableCutGradeValue]);

  /*API Binding Starts*/
  const handleCheckDealermembers = (id) => {
    try {
      let inputData = {
        dealerID: id,
      };

      GlobalGemstoneReportService.CheckDealermembers(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;

          // Calculate forDealer based on dealerMemberTypeName
          let forDealer;
          if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "VendorGemstone" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
          ) {
            forDealer = 1;
          } else if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "Retailer" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Combined"
          ) {
            forDealer = 2;
          } else {
            forDealer = 3;
          }

          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setForDealer(forDealer);
            } else {
              setForDealer("");
            }
            handleLoadChartReports(id, forDealer);
            handleGetGemstoneReportForTableChartAll(
              id,
              forDealer,
              pageNo,
              pageSize,
              sortColumnName,
              sortType
            );
          } else {
            setForDealer("");
          }
        })
        .catch((error) => {
          setForDealer("");
        });
    } catch (error) {
      setForDealer("");
    }
  };

  const handleLoadChartReports = (dealerId, forDealer) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "VendorGemstone"
      ) {
        forDealer = 1;
      }
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer.toString(),
        fromDate: globalGemstones.dataRangeFrom
          ? moment(globalGemstones.dataRangeFrom).format("YYYY-MM-DD")
          : "2016-03-07",
        toDate: globalGemstones.dataRangeTo
          ? moment(globalGemstones.dataRangeTo).format("YYYY-MM-DD")
          : "2023-04-06",
        selectedGemstoneValue: "All",
        addToType: "AddToCart",
      };
      setLoadChartReportsLoading(true);

      ReportsGemstoneService.AddToCartOrWishlistChartColunmData(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var GemstoneCutGradeSearchesList = responseData.VendorBasedData;
          var TotalGemstoneClicks =
            responseData.TotalGemstoneClicks[0].TotalClickCnt;
          setLoadChartReportsLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setTotalGemstoneClicks(TotalGemstoneClicks);
              setGemstoneCutGradeSearchesList(GemstoneCutGradeSearchesList);
              var GemstoneCutGradeSearchesLabelArr =
                GemstoneCutGradeSearchesList.map((item) => {
                  return item.VendorName;
                });
              setgemstoneCutGradeSearchesLabels(GemstoneCutGradeSearchesLabelArr);
              var GemstoneCutGradeYAxisList = GemstoneCutGradeSearchesList.map(
                (item) => {
                  return item.CNT;
                }
              );
              var GemstoneCutGradeColorList = GemstoneCutGradeSearchesList.map(
                (item) => {
                  return item.VendorName;
                }
              );
              setGemstoneCutGradeYAxisList(GemstoneCutGradeYAxisList);
              
              // Process data with max entries limit
              const { 
                chartData: processedChartData, 
                colors, 
                processedLabels, 
                processedCounts 
              } = processChartData(GemstoneCutGradeSearchesLabelArr, GemstoneCutGradeYAxisList);
              
              setChartData(processedChartData);
              setColorData(colors);
              setProcessedVendorLabels(processedLabels);
              setProcessedVendorCounts(processedCounts);
              
              gemstoneCutGradeColorHandler(GemstoneCutGradeColorList);
              setKey(!key);
            }
          } else {
            setTotalCount(0);
            setGemstoneCutGradeSearchesList([]);
            setGemstoneCutGradeYAxisList([]);
            setChartData([]);
            setColorData([]);
          }
        })
        .catch((error) => {
          setTotalCount(0);
          setGemstoneCutGradeSearchesList([]);
          setGemstoneCutGradeYAxisList([]);
          setLoadChartReportsLoading(false);
          setgemstoneCutGradeSearchesLabels([]);
          setChartData([]);
          setColorData([]);
        });
    } catch (error) {
      setTotalCount(0);
      setGemstoneCutGradeSearchesList([]);
      setGemstoneCutGradeYAxisList([]);
      setLoadChartReportsLoading(false);
      setgemstoneCutGradeSearchesLabels([]);
      setChartData([]);
      setColorData([]);
    }
  };

  const handleExportToCSV = (sortColumn, sorttype) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalGemstones.dataRangeFrom
          ? moment(globalGemstones.dataRangeFrom).format("YYYY-MM-DD")
          : "2016-03-12",
        toDate: globalGemstones.dataRangeTo
          ? moment(globalGemstones.dataRangeTo).format("YYYY-MM-DD")
          : "2023-04-11",
        clarity: "",
        cutGrade: "",
        shape: "",
        color: "",
        size: "",
        certificate: "",
        selectedGemstoneValue: "All",
        pageNumber: globalGemstones.pageNumber
          ? globalGemstones.pageNumber
          : pageNo,
        pageSize: globalGemstones.pageSiz ? globalGemstones.pageSiz : pageNo,
        sortOrderCol: sortColumn ? sortColumn : sortColumnName,
        sortOrderType: sorttype ? sorttype : sortType,
        addToType: "AddToCart",
        price: "",
        price1: "",
        price2: "",
        vendorIds: TableCutGradeValue ? TableCutGradeValue.toString() : "",
      };
      setDownloadCSVDataloading(true);
      ReportsGemstoneService.ExportDataToCSV(inputData)
        .then((response) => {
          setDownloadCSVDataloading(false);
          var fileName =
            loginDetials.loginDetials.responseData.dealerCompany.replace(/\s+/g, "") +
            "_GemstoneVendor_Report_" +
            new Date().toJSON().slice(0, 10).split("-").slice(1).concat(new Date().toJSON().slice(0, 4)).join("_") +
            ".csv";
          BlobToDownloadFile(response.data, fileName);
        })
        .catch((error) => {
          setDownloadCSVDataloading(false);
        });
    } catch (error) {
      setDownloadCSVDataloading(false);
    }
  };

  // Backend "Download PDF" (chart + Ranked Breakdown), same design as the
  // Gemstone Type report's Download PDF.
  const handleExportToPDF = () => {
    let forDealerId = forDealer;
    if (
      loginDetials.loginDetials.responseData.dealerMemberTypeName ===
      "VendorGemstone"
    ) {
      forDealerId = 1;
    }
    const fromDate = moment(globalGemstones.dataRangeFrom).format("YYYY-MM-DD");
    const toDate = moment(globalGemstones.dataRangeTo).format("YYYY-MM-DD");
    let inputData = {
      dealerID: dealerId ? dealerId.toString() : "",
      forDealer: forDealerId ? forDealerId.toString() : "",
      fromDate: fromDate,
      toDate: toDate,
      selectedGemstoneValue: "All",
      addToType: "AddToCart",
      reportName: "Vendor",
    };
    setDownloadPDFDataloading(true);
    ReportsGemstoneService.ExportAddToCartOrWishlistPdf(inputData)
      .then((response) => {
        setDownloadPDFDataloading(false);
        const fileName = `GemstoneVendor_AddToCart_${fromDate}_${toDate}.pdf`;
        BlobToDownloadFile(response.data, fileName, "pdf");
      })
      .catch(() => {
        setDownloadPDFDataloading(false);
        message.error(t("Failed to generate PDF. Please try again."));
      });
  };

  const handleGetGemstoneReportForTableChartAll = (
    dealerId,
    forDealer,
    pageNumber,
    pageSiz,
    sortColumn,
    sorttype
  ) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "VendorGemstone"
      ) {
        forDealer = 1;
      }
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalGemstones.dataRangeFrom
          ? moment(globalGemstones.dataRangeFrom).format("YYYY-MM-DD")
          : "2016-03-12",
        toDate: globalGemstones.dataRangeTo
          ? moment(globalGemstones.dataRangeTo).format("YYYY-MM-DD")
          : "2023-04-11",
        clarity: "",
        GemType: "",
        shape: "",
        color: "",
        size: "",
        certificate: "",
        selectedGemstoneValue: "All",
        pageNumber: pageNumber ? pageNumber : pageNo,
        pageSize: pageSiz ? pageSiz : pageNo,
        sortOrderCol: sortColumn ? sortColumn : sortColumnName,
        sortOrderType: sorttype ? sorttype : sortType,
        addToType: "AddToCart",
        price: "",
        price1: "",
        price2: "",
        vendorIds: TableCutGradeValue ? TableCutGradeValue.toString() : "",
      };

      setTableForAllLoading(true);

      ReportsGemstoneService.AddToCartOrWishlistReportForTableChart(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var TableForAllList = responseData.tableChartList;
          var TotalEventsCount = responseData.totalCount;
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setTotalCount(TotalEventsCount);
              setTableForAllList(TableForAllList);
              setTableForAllLoading(false);
            }
          } else {
            setTotalCount(0);
            setTableForAllList([]);
            setTableForAllLoading(false);
          }
        })
        .catch((error) => {
          setTotalCount(0);
          setTableForAllList([]);
          setTableForAllLoading(false);
        });
    } catch (error) {
      setTotalCount(0);
      setTableForAllList([]);
      setTableForAllLoading(false);
    }
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";

    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "DESC";
      column = "AK.Date";
      setSortColumnName(column);
      setSortType(type);
    }
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetGemstoneReportForTableChartAll(
      dealerId,
      forDealer,
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };
  /*API Binding Ends*/

  const gemstoneCutGradeColorHandler = (list) => {
    const color = [];
    for (let i = 0; i < list.length; i++) {
      color.push("rgb(66, 133, 244)");
    }
    setGemstoneCutGradeColorData(color);
  };

  /*DatePicker Binding Starts*/
  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalGemstone((prevState) => ({
        ...prevState,
        dataRangeFrom: moment.utc(dateStrings[0]).toISOString(),
        dataRangeTo: moment.utc(dateStrings[1]).toISOString(),
      }));
    }
  };
  /*DatePicker Binding Ends*/

  const handleApplyFilter = () => {
    handleLoadChartReports(dealerId, forDealer);
    handleGetGemstoneReportForTableChartAll(
      dealerId,
      forDealer,
      1,
      15,
      sortColumnName,
      sortType
    );
  };

  const chartOptions = {
    legend: { position: "none" },
    chartArea: { width: "80%", height: "80%" },
    hAxis: {
      title: "",
      slantedText: true,
      slantedTextAngle: 45,
    },
    vAxis: {
      title: "",
    },
    bar: { groupWidth: "70%" },
  };

  const handleSelect = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = chartData[selectedItem.row + 1][0];
      
      // Handle "Others" selection
      if (label === t("Others")) {
        // You might want to handle "Others" selection differently
        // For now, let's clear the vendor filter when "Others" is selected
        setTableCutGradeValue("");
        return;
      }
      
      setTableCutGradeValue(label);
    }
  };

  return (
    <React.Fragment>
      <div className="form__fields magento__mapping">
        <div className="row">
          <div className="col-md-12">
            <div className="edr-pagehead-row">
              <div className="edr-pagehead">
                <h1 className="edr-pagehead-title">{t("Gemstone Vendor based Add To Cart Report")}</h1>
                <div className="edr-pagehead-sub">
                  {moment(globalGemstones.dataRangeFrom).format("MMM D, YYYY")}
                  {" – "}
                  {moment(globalGemstones.dataRangeTo).format("MMM D, YYYY")}
                </div>
              </div>
              <div className="edr-pagehead-actions">
                <Button className="ghost-btn" onClick={handleExportToPDF} loading={downloadPDFDataloading}>
                  <i className="fa fa-download"></i> {t("Download PDF")}
                </Button>
                <button className="primary-btn" onClick={handleApplyFilter}>
                  {t("Apply Filter")}
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="row edr-filters">
              <div className="col-md-3">
                <div className="input__block dataRange-input-block datepicker__block">
                  <label> {t("Date Range")} </label>
                  <RangePicker
                    className="date-range-input"
                    ranges={{
                      Today: [moment(), moment()],
                      Yesterday: [
                        moment().subtract(1, "days"),
                        moment().subtract(1, "days"),
                      ],
                      "Last 7 Days": [moment().subtract(7, "days"), moment()],
                      "Last 30 Days": [moment().subtract(30, "days"), moment()],
                      "This Month": [
                        moment().startOf("month"),
                        moment().endOf("month"),
                      ],
                      "Last Month": [
                        moment().subtract(1, "month").startOf("month"),
                        moment().subtract(1, "months").endOf("month"),
                      ],
                      "Last 90 Days": [moment().subtract(90, "days"), moment()],
                      "Year To Date": [moment().startOf("year"), moment()],
                    }}
                    format={"MM-DD-YYYY"}
                    onChange={onDateChange}
                    defaultValue={[moment().subtract(30, "days"), moment()]}
                    defaultPickerValue={[moment().subtract(30, "days"), moment()]}
                  />
                </div>
              </div>
            </div>
          </div>

          {TableForAllList &&
            TableForAllList.length > 0 &&
            GemstoneCutGradeSearchesList.length > 0 && (
              <div className="col-lg-12 col-md-6">
                <div className="input__block">
                  <label>
                    <Spin spinning={LoadChartReportsLoading} size="small">
                      <b>
                        {" "}
                        {t("Total Clicks")} :{" "}
                        {TotalGemstoneClicks ? TotalGemstoneClicks : 0}
                      </b>
                    </Spin>
                  </label>
                </div>
              </div>
            )}

          <div className="chart__section" id="pdf-content-bar-chart">
            <Spin spinning={LoadChartReportsLoading} size="large">
              {TableForAllList && TableForAllList.length > 0 && chartData.length > 1 ? (
                <div>
                  {/* Custom Legend for Bar Chart */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      marginBottom: "15px",
                      gap: "8px",
                    }}
                  >
                    {chartData.slice(1).map((row, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          margin: "2px 4px",
                          fontSize: "12px",
                          fontWeight: "500",
                          padding: "4px 8px",
                          backgroundColor: "#f5f5f5",
                          borderRadius: "4px",
                          border: `2px solid ${colorData[index]}`,
                        }}
                      >
                        <div
                          style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: colorData[index],
                            marginRight: "6px",
                            borderRadius: "2px",
                          }}
                        ></div>
                        {row[0]} ({row[1]})
                      </div>
                    ))}
                  </div>

                  {/* Bar Chart */}
                  <div className="pdf-content-bar-chart">
                    <Chart
                      chartType="ColumnChart"
                      width={window.innerWidth > 500 ? "100%" : 300}
                      height={window.innerWidth > 500 ? 500 : 300}
                      data={chartData}
                      options={chartOptions}
                      chartEvents={[
                        {
                          eventName: "select",
                          callback: handleSelect,
                        },
                      ]}
                    />
                  </div>
                </div>
              ) : (
                <div className="no-report-render">
                  <div className="desc-space">
                    <h4 className="text-center">{t("No Data Found")}</h4>
                  </div>
                </div>
              )}
            </Spin>
          </div>

          <div className="col-lg-12 mt-3">
            <div className="options__div">
              <div className="row mb-4">
                <div className="col-lg-10 rules__div"></div>
                <div className="col-lg-12 mt-3 d-flex flex-column flex-lg-row justify-content-lg-end mb-3">
                  <Button
                    className="primary-btn mb-2 mb-lg-0 mr-2"
                    onClick={() => handleExportToCSV()}
                    loading={downloadCSVDataloading}
                  >
                    {" "}
                    <i className="fa fa-download"></i> {t("Download CSV")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12 col-md-12">
            <Table
              className="pendjewelreq__tbl"
                scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
              loading={TableForAllLoading}
              columns={[
                {
                  title: (
                    <Tooltip title={t("UserIPAddress")}>
                      {t("UserIPAddress")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "usersIPAddress",
                  sorter: (a, b) => {},
                },
                {
                  title: <Tooltip title={t("Date")}>{t("Date")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "date",
                  defaultSortOrder: "descend",
                  sorter: (a, b) => {},
                  render: (item, row) => {
                    return moment(row.date).format("MM-DD-YYYY, hh:mm:ss A");
                  },
                },
                {
                  title: <Tooltip title={t("Shape")}>{t("Shape")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "shape",
                  sorter: (a, b) => {},
                },
                {
                  title: <Tooltip title={t("Size")}>{t("Size")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "size",
                  sorter: (a, b) => {},
                },
                {
                  title: <Tooltip title={t("Color")}>{t("Color")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "color",
                  sorter: (a, b) => {},
                },
                {
                  title: <Tooltip title={t("Gem Type")}>{t("Gem Type")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "gemTypeName",
                  sorter: (a, b) => {},
                },

                {
                  title: <Tooltip title={t("Clarity")}>{t("Clarity")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "clarity",
                  sorter: (a, b) => {},
                },
                {
                  title: (
                    <Tooltip title={t("Certificate")}>
                      {t("Certificate")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "certificate",
                  sorter: (a, b) => {},
                },
                {
                  title: (
                    <Tooltip title={t("Retail Price")}>
                      {t("Retail Price")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "retailPrice",
                  sorter: (a, b) => {},
                  render: (retailPrice) => (
                    <Tooltip title={retailPrice}>
                      <span>{retailPrice}</span>
                    </Tooltip>
                  ),
                },
                {
                  title: <Tooltip title={t("Cost")}>{t("Cost")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "cost",
                  sorter: (a, b) => {},
                  render: (cost) => (
                    <Tooltip title={cost}>
                      <span>{cost}</span>
                    </Tooltip>
                  ),
                },
              ]}
              dataSource={TableForAllList}
              pagination={{
                size: "small",
                total: totalCount,
                pageNo: pageNo,
                pageSize: pageSize,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
              }}
              onChange={handleTableASCDES}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default GemstoneVendorBasedAddToCartReport;